import React from 'react';
import driverProfileStore from 'data/stores/DriverProfileStore';
import { observer } from 'mobx-react-lite';

 const DriverPersonalInfo=observer(() => {

    let driver = driverProfileStore.driver;
    return (
        <div className="card border">
            <div className="card-header border-bottom">
                <h4 className="card-header-title">Driver's Information</h4>
            </div>
            <div className="card-body">
                <form className="row g-3">
                    <div className="col-12">
                        <div className="d-flex align-items-center">
                            <label className="position-relative me-4" htmlFor="uploadfile-1" title="Replace this pic">
                                <span className="avatar avatar-xl">
                                    <img id="uploadfile-1-preview" className="avatar-img rounded-circle border border-white border-3 shadow" 
                                   src={driver && driver.profilePhotoUrl}  alt="no profile picture" />
                                </span>
                            </label>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Full Name</label>
                        <input type="text" readOnly className="form-control" value={driver ? driver.firstName + " " + driver.lastName : "Jacqueline Miller"} placeholder="Enter your full name" />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Email address</label>
                        <input type="email" readOnly className="form-control" value={driver ? driver.email : "hello@gmail.com"} placeholder="Enter your email id" />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Mobile number</label>
                        <input type="text" readOnly className="form-control" value={driver ? driver.phoneNumber : "222 555 666"} placeholder="Enter your mobile number" />
                    </div>
                </form>
            </div>
        </div>

    )
});

export default DriverPersonalInfo;